import React, { useState } from "react";
import { editCustomerInfoPostApi } from "../../../../Api/PanelAdminServices";
import { errorToast, succToast } from "../../../../Utils/Toast/Toast";
import Button from "../../../Button/Button";
import Style from "./EditCustomerInfo.module.scss";
const EditCustomerInfo = ({ rawInfo, handleOkAddress, UserList, type }) => {
  const [fname, setFname] = useState(rawInfo.fName);
  const [lname, setLname] = useState(rawInfo.lName);
  const [phone, setPhone] = useState(rawInfo.phone);
  const [disable, setDisable] = useState(false);

  const editInfo = () => {
    setDisable(true);
    let info = {
      id: rawInfo.id,
      first_name: fname,
      last_name: lname,
      phone: phone,
      user_type: type,
    };
    editCustomerInfoPostApi(info, (suc) => {
      if (suc.status === 1) {
        succToast(suc.message);
        setDisable(false);
      } else {
        errorToast(suc.message);
        setDisable(false);
      }
    });
    UserList();
    handleOkAddress();
  };
  return (
    <div className={Style.componentHolder}>
      <div className={Style.eachRaw}>
        <p className={Style.name}>:نام</p>
        <input
          value={fname}
          onChange={(e) => setFname(e.target.value)}
          className={Style.nameInput}
        />
      </div>
      <div className={Style.eachRaw}>
        <p className={Style.name}>:نام خانوادگی</p>
        <input
          value={lname}
          onChange={(e) => setLname(e.target.value)}
          className={Style.nameInput}
        />
      </div>
      <div className={Style.eachRaw}>
        <p className={Style.name}>:شماره تماس</p>
        <input
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          className={Style.nameInput}
        />
      </div>
      <Button
        Value={"ویرایش"}
        ClickHandler={editInfo}
        ClassBtn={"okBtn"}
        disabledprops={disable}
      />
    </div>
  );
};

export default EditCustomerInfo;
